module.exports = __webpack_public_path__ + "img/image00006-min.71f411bf.jpeg";